/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-16 10:03:09
 * @LastEditTime: 2019-10-21 20:16:19
 * @LastEditors: Please set LastEditors
 */
import {QueryResultInfo} from "./QueryResultInfo";
import {SuggestItemInfos} from "./SuggestItemInfos";

/// <summary>
/// 返回结果是建议词类型的信息
/// </summary>
export class ResultSuggestTypeInfo extends QueryResultInfo {

	constructor() {
		super();
		this.suggests = null;
		this.suggestsKey = null;
	}


	/**
		 *获得建议词类型的信息 
		 * @param jsonObject
		 * @return 
		 */
	static GetResultSuggestTypeInfo(jsonObject) {
		let suggestTypeInfo = null;
		if (jsonObject == null) return suggestTypeInfo;

		suggestTypeInfo = new ResultSuggestTypeInfo();
		suggestTypeInfo.SetResultBasicInfo(jsonObject);
		suggestTypeInfo.suggestsKey = jsonObject.suggestsKey;
		suggestTypeInfo.suggests = SuggestItemInfos.GetSuggestItems(jsonObject.suggests);

		return suggestTypeInfo;
	}

}//end ResultSuggestTypeInfo

